<template>
  <div class="utd-toast-stack">
    <slot />
  </div>
</template>

<script setup>
</script>

<style lang="less" scoped>
.utd-toast-stack {
  position: fixed;
  inset: auto 8px 16px;
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
  pointer-events: none;

  :deep(.utd-toast) {
    position: static;
    inset: auto;
    width: 100%;
    max-width: 600px;
    pointer-events: auto;
  }
}

@media screen and (min-width: 768px) {
  .utd-toast-stack {
    inset: 65px 16px auto auto;
    flex-direction: column;
    width: 350px;
  }
}
</style>
